import React from 'react';
import PropTypes from 'prop-types';

import Text from '../../../components/Text/Text';

const cardItemClassName = [
  'cursor-pointer border border-dashed border-[#F4F4F4] rounded-[4px]',
  'p-[9.75px] w-full',
  'sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-12px)] xl:max-w-[230px]'
].join(' ');
const titleClassName = 'text-text-main font-semibold text-[16px]';
const subtitleClassName = 'mr-[10px] font-medium';
const itemRowClassName = 'flex flex-row justify-start mt-[10px]';
const valueClassName = 'text-text-muted overflow-hidden whitespace-nowrap text-ellipsis';

const CarItem = ({
 make, model, year, openModal 
}) => (
  <div
    className={cardItemClassName}
    role="presentation"
    onClick={openModal}
  >
    <div><Text text={make} bold textStyle={titleClassName} /></div>
    <div className={itemRowClassName}>
      <div className={subtitleClassName}>Model:</div>
      <div className={valueClassName}>{model}</div>
    </div>
    <div className="flex flex-row justify-between mt-[10px]">
      <div className={subtitleClassName}>Year:</div>
      <div className={valueClassName}>{year}</div>
    </div>
  </div>
);

CarItem.propTypes = {
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
  openModal: PropTypes.func
};

CarItem.defaultProps = {
  openModal: () => {}
};

export default CarItem;
